import { render } from "./ButtonFilter.vue?vue&type=template&id=526e7e86&scoped=true"
import script from "./ButtonFilter.vue?vue&type=script&lang=js"
export * from "./ButtonFilter.vue?vue&type=script&lang=js"

import "./ButtonFilter.vue?vue&type=style&index=0&id=526e7e86&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526e7e86"]])

export default __exports__